// To use add the lazy-load="someurl" attribute to an image tag or the lazy-background="someurl" to any tag.

// Initialize thusly: var lazyLoader = new LazyLoading();

// Access api methods using the returned object. Example: lazyLoader.onLoaded(function() {});

// Broadcasts lazy-loaded event for jquery event listeners.

// Options Object
// loadedClass: Class to apply when the element is loaded
// loadingClass: Class to apply while the element is loading
// lazyImageSelector: Selector to use when finding images to lazy load.
// lazyBackgroundSelector: Selector to use when finding elements with background images to lazy load
// timeout: How long to wait before giving up waiting for the asset to load.

function LazyLoading(opts) {
	var that = this;
	var scheduled = [];
	var loading = false;
	var onAllLoadedCallback = null;
	var onLoadedCallback = null;
	var preloader = $('<img class="preloader">');

	var defaults = {
		loadedClass: 'loaded',
		loadingClass: 'loading',
		lazyImageSelector: '[lazy-load]',
		lazyBackgroundSelector: '[lazy-background]',
		timeout: 1000
	}

	if (!opts) opts = {};
	opts = $.extend(defaults, opts);

	lazyImages = $(opts.lazyImageSelector);
	lazyBackgrounds = $(opts.lazyBackgroundSelector);

	lazyBackgrounds.each(function() {
		scheduleLazyLoad($(this), $(this).attr('lazy-background'));
	});

	lazyImages.each(function() {
		scheduleLazyLoad($(this), $(this).attr('lazy-load'));
	});

	function scheduleLazyLoad(elem, imageUrl, callback) {
		scheduled.push({elem: elem, imageUrl: imageUrl, callback: callback});
		if (!loading)
			doLazyLoad();
	}

	function doLazyLoad() {
		var next = scheduled.shift();
		if (!next) {
			if (onAllLoadedCallback)
				onAllLoadedCallback();
			return loading = false;
		}

		lazyLoad(next.elem, next.imageUrl, function() {
			if (next.callback)
				next.callback.bind(next.elem)();
			doLazyLoad();
		});
	}

	function lazyLoad(element, imageUrl, done) {
		var isImage = false;
		if (element.is('img'))
			isImage = true;

		var loaderImage = isImage ? element : preloader;

		function loaded() {
			clearTimeout(timeout);

			// Give a slight delay for the browser to render.
			setTimeout(function() {
				element.removeClass(opts.loadingClass);
				element.addClass(opts.loadedClass);
			}, 100);

			if (onLoadedCallback)
				onLoadedCallback(element);

			if (!isImage) {
				element.css('background-image', 'url("' + imageUrl + '")');
				loaderImage.unbind('load').remove();
			}

			// Broadcast that this has run, so we can have code run after it is sized
			element.triggerHandler('lazy-loaded');

			done();
		}
		var timeout = setTimeout(loaded, opts.timeout);
		loaderImage.load(loaded);
		loaderImage.attr('src', imageUrl);
		element.addClass(opts.loadingClass);
	}

	// API

	// Register a callback for when an asset finishes laoding.
	this.onLoaded = function(callback) {
		onLoadedCallback = callback;
	}
	// Register a callback for when all assets have finished loading.
	this.onAllLoaded = function(callback) {
		onAllLoadedCallback = callback;
	}
	// Initiate a manual lazy load. Useful for when asynchronously loading html that includes lazy load attributes.
	this.lazyLoad = function(elem, imageUrl, callback) {
		scheduleLazyLoad(elem, imageUrl, callback);
	}
	return this;
}

